import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import { lazy } from 'react';
import type { componentNames } from './componentNames';

type SwipeAdCreativesConfigComponentKeys = (typeof componentNames)[number];

export const stConfig: CreativesConfig<SwipeAdCreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.ST,
  name: 'Swipe Ad',
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    mobile: '(((max-width: 450px) and (max-height: 700px)) or (max-width: 350px))',
    largeMobile: '(max-width: 549px) and (max-height: 849px)',
  },
  components: {
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
      defaults: {
        ...defaultCreativesConfig.components.closeAd.defaults,
        centered: true,
      },
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    headerTitle: {
      ...defaultCreativesConfig.components.headerTitle,
    },
    productSwiper: {
      ...defaultCreativesConfig.components.productSwiper,
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
    },
    store: {
      ...defaultCreativesConfig.components.store,
      wrapper: lazy(() => import('@ad-lucy/st/components/Store')),
      defaults: {
        ...defaultCreativesConfig.components.store.defaults,
        linkOutOnStoreClick: false,
        defaultAndDetailsClickTrackerTrigger: 'content-branch',
      },
    },
    storeV2: {
      ...defaultCreativesConfig.components.storeV2,
      wrapper: lazy(() => import('@ad-lucy/components/builderComponents/StoreV2')),
      defaults: {
        ...defaultCreativesConfig.components.storeV2.defaults,
        linkOutOnStoreClick: false,
        defaultAndDetailsClickTrackerTrigger: 'content-branch',
      },
    },
  },
};
